/*
 *  -----------------------------------------------------------------------
 *    <copyright file="import-summary/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';
import React from 'react';
import { useTranslation } from 'hooks';
import Button from 'views/components/core/buttons';
import { CustomDialog, DialogActions, DialogTitle } from 'views/components/core/dialog';
import TextField from 'views/components/core/text-field';

const ImportSummary = ({ summary, open, onClose }: { open: boolean; onClose: Function; summary?: string }) => {
    const { t } = useTranslation();

    const close = () => {
        onClose();
    };

    return (
        <CustomDialog onClose={close} fullWidth maxWidth="md" scroll="paper" open={open}>
            <DialogTitle id="import-summary-config-modal-title">
                {t('admin:importSummary')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={close}
                    data-testid="close-dialog"
                />
            </DialogTitle>
            <DialogContent className="import-study-dialog-content">
                <TextField
                    label={t('admin:importLog')}
                    id="import-log"
                    multiline
                    rows={20}
                    fullWidth
                    defaultValue={summary}
                    variant="outlined"
                    color="secondary"
                    className="mb non-disabled"
                    disabled
                />
                <DialogActions className="import-study-actions flex-end">
                    <Button id="import-summary-study-btn" text="close" onClick={close} />
                </DialogActions>
            </DialogContent>
        </CustomDialog>
    );
};

export default ImportSummary;
